import { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';
import { useToast } from './Toast';

/** "En ny version finns tillgänglig" as a toast with an Uppdatera action. */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW();
  const toast = useToast();

  useEffect(() => {
    if (!needRefresh) return;
    const id = toast.show('En ny version finns tillgänglig.', {
      key: 'sw-update',
      duration: 0,
      action: { label: 'Uppdatera', onClick: () => void updateServiceWorker(true) },
    });
    return () => {
      toast.dismiss(id);
      setNeedRefresh(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [needRefresh]);

  return null;
}
